/* FOUZIES · Bildergalerien (Vorlage: galPrev / galNext / galGo / galSwipe) */
(function () {
  if (window.__fzsGallery) return;
  window.__fzsGallery = true;

  function show(gal, i) {
    var slides = gal.querySelectorAll('[data-fzs-slide]');
    var n = slides.length;
    if (!n) return;
    i = ((i % n) + n) % n;
    gal.setAttribute('data-idx', i);
    for (var k = 0; k < n; k++) {
      slides[k].style.opacity = k === i ? '1' : '0';
      slides[k].style.pointerEvents = k === i ? 'auto' : 'none';
    }
    var marks = gal.querySelectorAll('.fzs-gal-mark');
    for (var m = 0; m < marks.length; m++) {
      marks[m].style.background = m === i ? '#1D1D1B' : 'transparent';
    }
  }
  function current(gal) { return parseInt(gal.getAttribute('data-idx') || '0', 10); }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-fzs-prev],[data-fzs-next],[data-fzs-go]');
    if (!btn) return;
    var gal = btn.closest('[data-fzs-gal]');
    if (!gal) return;
    e.preventDefault();
    if (btn.hasAttribute('data-fzs-prev')) show(gal, current(gal) - 1);
    else if (btn.hasAttribute('data-fzs-next')) show(gal, current(gal) + 1);
    else show(gal, parseInt(btn.getAttribute('data-fzs-go'), 10));
  });

  var sx = 0, sy = 0, live = null;
  document.addEventListener('touchstart', function (e) {
    var gal = e.target.closest('[data-fzs-gal]');
    if (!gal) { live = null; return; }
    sx = e.touches[0].clientX; sy = e.touches[0].clientY; live = gal;
  }, { passive: true });
  document.addEventListener('touchmove', function (e) {
    if (!live) return;
    var t = e.touches[0];
    if (Math.abs(t.clientY - sy) > Math.abs(t.clientX - sx)) live = null;
  }, { passive: true });
  document.addEventListener('touchend', function (e) {
    if (!live) return;
    var dx = e.changedTouches[0].clientX - sx;
    if (Math.abs(dx) > 40) show(live, current(live) + (dx < 0 ? 1 : -1));
    live = null;
  }, { passive: true });
})();
